export const isDevMode = process.env.NEXT_PUBLIC_DEV_MODE === "true";
